import { createFileRoute } from '@tanstack/react-router'
import { AssistantPage } from '@/components/assistant/assistant-page'

export const Route = createFileRoute('/assistant')({
  component: AssistantPage,
})
